export const COMPUTER_EFFORT_PREFERENCES_STORAGE_KEY = 'computerEffortPreferences-v10';
//# sourceMappingURL=types.js.map